<script>
    export let handleClick;
    export let buttonClass = "";
    export let content;
    export let isDisabled = false;
</script>

<button
    class="border-0 bg-lightBlue-500 p-2 px-4 font-semibold hover:shadow-lg w-44 focus:outline-none disabled:opacity-30 {buttonClass}"
    on:click|preventDefault={handleClick}
    disabled={isDisabled}
>
    {content}
</button>